/**
 * Utility functions for extracting URLs from markdown text.
 */

/**
 * Extracts web URLs (HTTP/HTTPS) from markdown text.
 *
 * This function uses a regex pattern to find all HTTP and HTTPS URLs
 * in the provided text, including URLs in markdown link syntax.
 *
 * @param text - The markdown text to extract URLs from
 * @returns Array of unique URLs found in the text
 */
export function extractWebUrlsFromMarkdown(text: string): string[] {
  if (!text) {
    return [];
  }

  // Regex pattern to match HTTP/HTTPS URLs
  // Matches URLs in plain text and within markdown link syntax [text](url)
  const urlPattern = /https?:\/\/[^\s)\]]+/gi;

  const matches = text.match(urlPattern);

  if (!matches) {
    return [];
  }

  // Remove duplicates and clean up URLs
  const uniqueUrls = Array.from(new Set(matches)).map((url) => {
    // Remove trailing punctuation that might be part of markdown syntax
    return url.replace(/[.,;:!?)\]]+$/, '');
  });

  return uniqueUrls;
}
